import { useMicroCopy } from '@ecomm/micro-copy'
import { useTrackMetricEvent } from '@ecomm/tracking'
import { window } from 'browser-monads-ts'
import { useEffect } from 'react'
import { useTracking } from 'react-tracking'

type Props = {
  readonly error: Error
}

export function ErrorMessage({ error }: Props) {
  const microCopy = useMicroCopy()
  const trackMetricEvent = useTrackMetricEvent()
  const { trackEvent } = useTracking()

  useEffect(() => {
    // track PageAction to NR
    trackMetricEvent('cart-render-error', {
      shippingViewed: String(window.location.pathname === '/cart/checkout'),
      paymentViewed: String(window.location.pathname === '/payment-page'),
      error: `${error.name}: ${error.message}`
    })
    // track to GA via GTM
    trackEvent({
      event: 'cart-render-error',
      error: `${error.name}: ${error.message}`
    })
  }, [error.message, error.name, trackMetricEvent, trackEvent])

  return (
    <div
      className="h-full min-h-[350px] text-center md:min-h-[400px] lg:min-h-[600px]"
      data-component="CartRetrievalErrorMessage"
    >
      <h2>{microCopy['cart-error-state-heading']}</h2>
      <p>{microCopy['cart-error-state-subheading']}</p>
    </div>
  )
}
